{
    "Accessibility Menu": "Μενού προσβασιμότητας",
    "Reset settings": "Επαναφορά ρυθμίσεων",
    "Close": "Κλείσιμο",
    "Content Adjustments": "Προσαρμογές περιεχομένου",
    "Adjust Font Size": "Προσαρμογή μεγέθους γραμματοσειράς",
    "Highlight Title": "Επισήμανση τίτλου",
    "Highlight Links": "Επισήμανση συνδέσμων",
    "Readable Font": "Ευανάγνωστη γραμματοσειρά",
    "Color Adjustments": "Προσαρμογές χρωμάτων",
    "Dark Contrast": "Αντίθεση σε σκούρο",
    "Light Contrast": "Αντίθεση σε φωτεινό",
    "High Contrast": "Υψηλή αντίθεση",
    "High Saturation": "Υψηλός κορεσμός",
    "Low Saturation": "Χαμηλός κορεσμός",
    "Monochrome": "Μονόχρωμο",
    "Protanopia": "Πρωτανοπία",
    "Deuteranopia": "Δευτερανοπία",
    "Tritanopia": "Τριτανοπία",
    "Visual & Navigation Aids": "Οπτικά και πλοηγητικά βοηθήματα",
    "Additional Tools": "Πρόσθετα εργαλεία",
    "Reading Guide": "Οδηγός ανάγνωσης",
    "Stop Animations": "Αφαίρεση κίνησης",
    "Big Cursor": "Μεγάλος κέρσορας",
    "Screen Reader": "Αναγνώστης οθόνης",
    "Hide Images": "Απόκρυψη εικόνων",
    "Image Tooltips": "Συμβουλές εικόνων",
    "Page Structure": "Δομή σελίδας",
    "Super Focus": "Υπερεστίαση",
    "Magnifier": "Μεγεθυντής",
    "Increase Font Size": "Αύξηση μεγέθους γραμματοσειράς",
    "Decrease Font Size": "Μείωση μεγέθους γραμματοσειράς",
    "Letter Spacing": "Διάκενο γραμμάτων",
    "Line Height": "Ύψος γραμμής",
    "Font Weight": "Βάρος γραμματοσειράς",
    "Dyslexia Font": "Γραμματοσειρά για δυσλεξία",
    "Language": "Γλώσσα",
    "Open Accessibility Menu": "Ανοίξτε το μενού προσβασιμότητας",
    "Accessibility Profiles": "Προφίλ προσβασιμότητας",
    "Seizure Safe Profile": "Ασφαλές προφίλ για επιληψία",
    "Stops animations and reduces color saturation.": "Σταματά τις κινήσεις και μειώνει τον κορεσμό χρωμάτων.",
    "Blind Profile": "Προφίλ για τυφλούς",
    "Activates the screen reader for auditory navigation.": "Ενεργοποιεί τον αναγνώστη οθόνης για ηχητική πλοήγηση.",
    "Visually Impaired Profile": "Προφίλ για άτομα με μειωμένη όραση",
    "Enhances contrast and readability for low vision.": "Βελτιώνει την αντίθεση και την αναγνωσιμότητα για χαμηλή όραση.",
    "ADHD Friendly Profile": "Φιλικό προφίλ για ΔΕΠΥ",
    "Reduces distractions for better focus.": "Μειώνει τους περισπασμούς για καλύτερη εστίαση.",
    "Cognitive & Learning Profile": "Γνωστικό και εκπαιδευτικό προφίλ",
    "Helpful tools for reading and comprehension.": "Χρήσιμα εργαλεία για ανάγνωση και κατανόηση.",
    "Motor Impaired Profile": "Προφίλ κινητικής αναπηρίας",
    "Optimizes the site for keyboard-only navigation.": "Βελτιστοποιεί τον ιστότοπο για πλοήγηση μόνο με πληκτρολόγιο.",
    "Headings": "Επικεφαλίδες",
    "Landmarks": "Ορόσημα",
    "Links": "Σύνδεσμοι",
    "Focus element": "Εστίαση σε στοιχείο",
    "Visit link": "Επίσκεψη συνδέσμου"
}